const getBrowser = () => {
    if (typeof window === 'undefined' || !(window?.navigator || {}).userAgent) {
        return 'unknown';
    }

    const { userAgent } = window.navigator;

    if (userAgent.indexOf('Chrome') > -1) {
        return 'Chrome';
    }

    if (userAgent.indexOf('Firefox') > -1) {
        return 'Firefox';
    }

    if (userAgent.indexOf('Safari') > -1) {
        return 'Safari';
    }

    return 'unknown';
};
